import React from "react";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import DeleteResource from "../DeleteResource/DeleteResource";

const DeleteResourceModalContainer = ({ visible, onClose, onDeleteResource, type }) => {
  const { isMedium } = useResponsiveScreen();

  const getDisplayName = (resourceType) => {
    const displayNames = {
      review: "Review",
      aiTutor: "AiTutor",
      aitutor: "AiTutor",
      assignment: "Assignment",
      resource: "Resource",
      axioResource: "Resource",
      module: "Module",
      ACTIVITY_REVIEW: "Review",
      ACTIVITY_INTERACTIVE_LEARNING_EXPERIENCE: "AI Tutor",
      ACTIVITY_ASSIGNMENT: "Assignment",
      ACTIVITY_RESOURCE: "Resource",
      MODULE: "Module",
    };

    return displayNames[resourceType] || resourceType;
  };

  const handleDelete = () => {
    onDeleteResource();
  };

  const displayName = getDisplayName(type);

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title={`Delete ${displayName}`}
      style={{ width: isMedium ? "50%" : "90%" }}>
      <DeleteResource deleteButtonClick={handleDelete} backButtonClick={onClose} type={displayName} />
    </CustomModal>
  );
};

export default DeleteResourceModalContainer;
